import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Badge = ({ classes, variant, text, outline, pill }) => {
  const { t } = useTranslation();

  const baseClass = outline ? 'theme-badge-outline-' : 'theme-badge-';

  return (
    <div className={`${baseClass}${variant}${pill ? ' rounded-pill' : ''} ${classes || ''}`}>
      {t(text)}
    </div>
  );
};

Badge.propTypes = {
  classes: PropTypes.string,
  variant: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  outline: PropTypes.bool,
  pill: PropTypes.bool,
};

export default Badge;
